import * as React from 'react';

import { CoachDisclosure } from 'bundles/ai-course-coach/components/common';
import type { CmlContent } from 'bundles/cml';
import { CMLViewer } from 'bundles/cml';

export type Props = {
  feedback: CmlContent;
};

const AiGradedRubricCoachFeedback = ({ feedback }: Props) => {
  return (
    <CoachDisclosure defaultExpanded collapsible={false}>
      <CMLViewer cml={feedback} />
    </CoachDisclosure>
  );
};

export default AiGradedRubricCoachFeedback;
